import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { fetchLocations } from '@api/fetchLocations'
import { LocationWithLanes } from '@clear-denver/tpc-bff-client/build/api/tpc-bff/types'
import getEnrollmentLocationData from '@api/getEnrollmentLocations'

export type LocationsState = {
  enrollmentLocations: LocationWithLanes[]
}

const defaultInitialState: LocationsState = {
  enrollmentLocations: [],
}

export const LocationsContext =
  createContext<LocationsState>(defaultInitialState)

export function LocationsProvider({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const [enrollmentLocations, setEnrollmentLocations] =
    useState<LocationWithLanes[]>()

  useEffect(() => {
    const fetchData = async () => {
      const staticLocations = await getEnrollmentLocationData()
      const locations = await fetchLocations()

      setEnrollmentLocations(
        (locations[1]?.data as unknown as LocationWithLanes[]) ||
          staticLocations
      )
    }
    fetchData()
  }, [])

  const values = useMemo(
    () => ({
      enrollmentLocations,
    }),
    [enrollmentLocations]
  )
  return (
    <LocationsContext.Provider value={values}>
      {children}
    </LocationsContext.Provider>
  )
}

export const useLocationsContext = () => {
  const context = useContext(LocationsContext)
  if (!context) {
    throw new Error(
      `${useLocationsContext.name} must be used within a ${LocationsProvider.name}`
    )
  }
  return context
}
